import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, FormControl, MenuItem, Select, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import { getBranchList } from '../setting/services/settingApi'
import { PLAN_CONFIG } from './config'
import PlanContext from './services/planApi'
import api from '../../api/api'
import dayjs from 'dayjs'
import ConfirmDialogPlancampaign from './component/confirmDialogPlancampaign'
import ConfirmPlanPrint from './component/confirmPlanPrint'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'

export default function ViewCampaignPlan() {
    const { id } = useParams()
    const [searchParams, setSearchParams] = useSearchParams()
    const { profile, loading } = useSelector(state => state.profile)
    const navigate = useNavigate();

    const { GetCampaignInfo } = useContext(PlanContext);
    let CampaignName = searchParams.get('CampaignName') || ''
    let BranchNo = searchParams.get('BranchNo') || ''
    const [detail, setDetail] = useState()
    const [rows, setRows] = useState()
    const [branchs, setBranchs] = useState([])
    const [open, setOpen] = useState(false)
    const [openP, setOpenP] = useState(false)
    useEffect(() => {
        GetCampaignInfo(id, BranchNo, setDetail)
        getBranchList(null, setBranchs)
    }, [])
    useEffect(() => {
        setRows(detail?.InspectionDetails)
    }, [detail])
    const handleSubmit = () => {
        const body = {
            InspectionDetails: rows
        }

        const planCampaignAdd = async () => {
            const _DocumentNo = encodeURIComponent(id);

            const url = PLAN_CONFIG.requests.getPlanCampaigns.url + `/${_DocumentNo}`;

            const res = await api.post(url, body)
            const data = res.data
            if (data.status === true) {

                setOpen(false)
                setOpenP(true)
            }
            else {
                Swal.fire({
                    title: data?.message || 'ทำรายการไม่สำเร็จ',
                    icon: 'warning',
                })
            }
        }
        planCampaignAdd()
    }
    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <form >
                    <div class="container-fluid">
                        <div class="d-flex row align-items-center ">
                            <div class="col-12">
                                <label class="title-content mb-4">
                                    ข้อมูลใบตรวจการปฏิบัติงาน
                                </label>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-md-12">
                                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <FormControl variant="standard" fullWidth disabled>
                                        <Select value={BranchNo || ''} disableUnderline >
                                            {branchs?.map((x) => (
                                                <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput">โครงการ</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={CampaignName} variant="standard" fullWidth disabled
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>


                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={detail?.CreateId} variant="standard" fullWidth disabled
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label"> ( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )
                                </label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={detail?.ModifiedId} variant="standard" fullWidth disabled
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>



                        <div class="row">

                            <div class="col-md-12 table-responsive-sm pb-3" style={{ height: 'auto' }}>
                                <table class="table table-bordered table-hover ">
                                    <thead>
                                        <tr>

                                            <th scope="col " rowspan="2" class="text-center">จังหวัด</th>
                                            <th scope="col " rowspan="2" class="text-center">พันธุ์/ชั้นพันธุ์</th>
                                            <th scope="col " rowspan="2" class="text-center">ราคารวมค่าขนส่ง (บาท/กิโลกรัม)</th>
                                            <th scope="col " rowspan="2" class="text-center">จำนวนเมล็ดพันธุ์ (กิโลกรัม)</th>
                                            <th scope="col " rowspan="2" class="text-center">จำนวนเงินค่าเมล็ดพันธุ์ (บาท)</th>
                                            <th scope="col " colspan="5" class="text-center">คุณภาพ</th>
                                        </tr>
                                        <tr>

                                            <th scope="col " class="text-center">ความงอก (%)</th>
                                            <th scope="col " class="text-center">เมล็ดพันธุ์สุทธิ (%)</th>
                                            <th scope="col " class="text-center">พันธุ์ปน (จำนวนเมล็ดใน 500 กรัม)</th>
                                            <th scope="col " class="text-center">ข้าวแดง (จำนวนเมล็ดใน 500 กรัม)</th>
                                            <th scope="col " class="text-center">ความชื้น (%)</th>
                                        </tr>

                                    </thead>
                                    <tbody class="">
                                        {rows?.map((x, i) =>
                                            <tr>

                                                <td class="text-center">{x?.Province}</td>
                                                <td class="text-center">
                                                    {x?.CatalogName} / {x?.ItemClass}
                                                </td>
                                                <td class="text-center">{parseFloat(x?.TotalPrice).toFixed(2)
                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                <td class="text-center">{x?.Qty}</td>
                                                <td class="text-center">{parseFloat(x?.SalePrice).toFixed(2)
                                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                                <td class="text-center">
                                                    <TextField value={x?.Germin} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.Germin = index === i ? e.target.value : v?.Germin;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} /></td>
                                                <td class="text-center">
                                                    <TextField value={x?.NetPercent} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.NetPercent = index === i ? e.target.value : v?.NetPercent;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />
                                                </td>
                                                <td class="text-center">
                                                    <TextField value={x?.Mixed} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.Mixed = index === i ? e.target.value : v?.Mixed;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />
                                                </td>
                                                <td class="text-center">
                                                    <TextField value={x?.RedRice} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.RedRice = index === i ? e.target.value : v?.RedRice;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />
                                                </td>
                                                <td class="text-center">
                                                    <TextField value={x?.Humid} size='small' fullWidth variant='outlined' onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.Humid = index === i ? e.target.value : v?.Humid;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }} />
                                                </td>

                                            </tr>)}

                                    </tbody>
                                </table>
                            </div>


                        </div>
                        <hr class="chr" />
                        <div class="row mt-4">

                            <div class="col-12 ">
                                <Button variant='outlined'  onClick={() => navigate(-1)} startIcon={<FontAwesomeIcon icon={faArrowLeft} />} sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                                <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => setOpen(true)}>เเก้ไข</Button>
                            </div>
                        </div>
                    </div>
                </form>
            </Page>
            <ConfirmDialogPlancampaign open={open} setOpen={setOpen} rows={rows} handleAdd={handleSubmit} BranchNo={BranchNo} branchName={branchs} campaignsName={CampaignName}/>
            <ConfirmPlanPrint title={'บันทึกข้อมูลใบตรวจการปฏิบัติงานสำเร็จ'} download={null} open={openP} setOpen={setOpenP} loadingPDF={null} linkTo='/plan/campaign-plan' />
        </div>
    )
}
